import {
  BIndexThresholdType,
  useSearchQuestionItemAnalysisYearlyRecordsQuery,
} from '@report/graphql';
import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useItemAnalysisYearlySearchParams } from '../../hooks';
import { ItemAnalysisYearlyReportExportModal } from '../item-analysis-yearly-report-export-modal';
import { monthIndexMap } from '../item-analysis-yearly-table';

export default function ItemAnalysisYearlyReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();
  const [
    {
      page,
      pageSize,
      startMonth,
      endMonth,
      startYear,
      endYear,
      examCourse,
      questionStatus,
      minExaminees,
      knowledgeGroupSelection,
      knowledgeGroupCustomThreshold,
      nonKnowledgeGroupSelection,
      nonKnowledgeGroupCustomThreshold,
    },
  ] = useItemAnalysisYearlySearchParams();

  const isFilterSet =
    !!startMonth &&
    !!endMonth &&
    !!startYear &&
    !!endYear &&
    !!examCourse &&
    questionStatus.length > 0 &&
    minExaminees !== null &&
    knowledgeGroupSelection !== null &&
    (knowledgeGroupSelection !== BIndexThresholdType.CustomThreshold ||
      knowledgeGroupCustomThreshold != null) &&
    nonKnowledgeGroupSelection !== null &&
    (nonKnowledgeGroupSelection !== BIndexThresholdType.CustomThreshold ||
      nonKnowledgeGroupCustomThreshold != null);

  const { data: searchData } = useSearchQuestionItemAnalysisYearlyRecordsQuery({
    variables: {
      searchQuestionItemAnalysisYearlyRecordsInput: {
        startedAt: new Date(
          startYear && startMonth
            ? Date.UTC(startYear, monthIndexMap[startMonth] - 1, 0, 17, 0, 0)
            : '',
        ),
        questionStatus: questionStatus,
        qBankStructureId: examCourse ?? '',
        paging: {
          pageSize: pageSize,
          currentPage: page,
        },
        nonKnowledgeGroup: {
          value: nonKnowledgeGroupCustomThreshold ?? undefined,
          type: nonKnowledgeGroupSelection ?? null,
        },
        minimumExamineePerQuestion: minExaminees ?? 0,
        knowledgeGroup: {
          value: knowledgeGroupCustomThreshold ?? undefined,
          type: knowledgeGroupSelection ?? null,
        },
        endedAt: new Date(
          endYear && endMonth
            ? new Date(Date.UTC(endYear, monthIndexMap[endMonth], 0, 16, 59, 59))
            : '',
        ),
      },
    },
    skip: !isFilterSet,
  });
  const totalCount = searchData?.reportSearchQuestionItemAnalysisYearlyRecords.total ?? 0;
  const shouldDisable = totalCount === 0;

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <ItemAnalysisYearlyReportExportModal
        open={isModalOpen}
        onClose={closeModal}
        totalCount={totalCount}
      />
    </>
  );
}
